import { render, staticRenderFns } from "./ManageCustomers.vue?vue&type=template&id=38ef716a&lang=true"
import script from "./ManageCustomers.vue?vue&type=script&lang=js"
export * from "./ManageCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports